module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_lpo-84fc29c04a5c224add0c6c9e3678580f.svg";